import React from 'react'
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap'

const UpiInfoTable = (props) => {

    return (
        <Modal className="payment-schedule" isOpen={props.showPopUpText} toggle={props.toggleInfoPopup} size="lg">
            <ModalHeader toggle={props.toggleInfoPopup}></ModalHeader>
            <ModalBody>
                <Table bordered>
                    <tr className="table-header">
                        <th>Sr. No.</th>
                        <th>UPI Apps live</th>
                        <th> Handle </th>
                    </tr>
                    {props?.upiList.map((item, key) =>
                        <tr className='text-center' key={item.ISIN}>
                            <td>
                                {key}
                            </td>
                            <td>
                                {item.name}
                            </td>
                            <td>
                                {item.handle}
                            </td>
                        </tr>
                    )
                    }
                </Table>
            </ModalBody>
        </Modal>
    )
}

export default UpiInfoTable